import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { AlertTriangle } from 'lucide-react';

const ID_OK = ['verified', 'verified_manual', 'not_required'];

export const ApproveDialog = ({ open, onOpenChange, client, checklist, identity, portalLogin, selfRegistered = true, busy, onConfirm }) => {
  const [reason, setReason] = useState('');
  const [invite, setInvite] = useState(true);
  const notSubmitted = client.status !== 'active' && !client.onboarding_submitted;
  const idOk = ID_OK.includes(identity?.id_verification_status) || identity?.didit_status === 'Approved';
  const canInvite = client.status !== 'active' && !portalLogin && selfRegistered;
  const blocked = notSubmitted && reason.trim().length < 3;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="approve-dialog">
        <DialogHeader>
          <DialogTitle>Approve {client.display_name}?</DialogTitle>
          <DialogDescription>The client becomes active.</DialogDescription>
        </DialogHeader>
        {notSubmitted && (
          <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 space-y-2" data-testid="approve-not-submitted-warning">
            <p className="flex items-center gap-2 font-medium"><AlertTriangle className="w-4 h-4" />
              Onboarding not submitted ({checklist?.completion_pct ?? 0}% complete, ID {idOk ? 'verified' : 'not verified'}). Approve anyway?</p>
            <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (recorded in the audit log)" data-testid="approve-reason" />
          </div>
        )}
        {canInvite && (
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={invite} onChange={(e) => setInvite(e.target.checked)} data-testid="approve-send-invite" />
            Send portal invite (email with a link to set up their secure login for this client)
          </label>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button disabled={busy || blocked} onClick={() => onConfirm({ force: notSubmitted, reason: notSubmitted ? reason.trim() : undefined, send_invite: canInvite && invite })} data-testid="approve-confirm">
            {notSubmitted ? 'Approve anyway' : 'Approve'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
